



































import { Component, Vue, Prop } from 'vue-property-decorator';
import CountdownTimer from '~/components/Promotions/CountdownTimer.vue';

@Component({ components: { CountdownTimer } })
export default class CountdownTimerWithMessage extends Vue {
  @Prop(Number) endTime!: number;
  @Prop(String) tooltipText!: string;
  @Prop(String) runningLabel!: string;
  @Prop(String) timeExpiredLabel!: string;
  @Prop(Boolean) bottom!: boolean;
  @Prop({ type: String, default: '15px' }) fontSize!: string;
  @Prop({ type: String, default: '#F85B6B' }) color!: string;

  expired = false;
}
